import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Grid} from 'react-virtualized';

import NavigationItemsList from "../navigationItemsList";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import UserLoginButton from "../../../ui/userLoginButton";
import {UserPopupTypes} from "../../constants";
import {CABINET_WIZARD_BUTTONS} from "../../../kvComponent/core/constants";
import NavigationFilters from "../newFilters/navigationFilters";
import {getActivePartsCounts} from "../navUtils";
import {
  changeActivePartRelatedItemIndex, setCameFromPage, setQtActiveCategory, toggleBathroomVisualizerOpen,
  toggleSelectionFeatureInfo, toggleSelectionWindow
} from "../../../../actions/actionFunctions";
import {checkIfNeedToReceiveFeaturesIfFiltersApplied} from "../../../../misc/filtersFunctions";

class MobileNavigationBodyNewClass extends NavigationItemsList {

  static propTypes = {
    features: PropTypes.arrayOf(PropTypes.instanceOf(DesignNavigationItem)),
    parentItem: PropTypes.instanceOf(DesignNavigationItem),
    childItem: PropTypes.instanceOf(DesignNavigationItem),
    toggleUserPopup: PropTypes.func,
    onItemClick: PropTypes.func,
    userIsLoggedIn: PropTypes.bool,
    showMobileMenu: PropTypes.bool,
    isPhoneNumberValidated: PropTypes.bool,
    activeFeature: PropTypes.object,
    searchText: PropTypes.string,
    allFeaturesReceived: PropTypes.bool,
    existInQtCategory: PropTypes.bool,
    layoutName: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {
      showPlaceHolders: document.bvConfig ? document.bvConfig.showPlaceholders : false,
      itemClicked: false,
      reorderedFeatures: [],
      // showLoader: false,
    };
    this.childItemText = "";
    this.parentItemText = "";
    // this._isMounted = false;
  }

  componentDidMount() {
    this.reorderItems(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      (nextProps.childItem && (nextProps.childItem.text !== this.childItemText))
        || (nextProps.showMobileMenu && !this.props.showMobileMenu)
        || (!nextProps.childItem && nextProps.parentItem && (nextProps.parentItem.text !== this.parentItemText))
        || (this.props.selectedFilters.length !== nextProps.selectedFilters.length)
        || (this.props.searchText !== nextProps.searchText)
        || (nextProps.allFeaturesReceived && !this.props.allFeaturesReceived)
        || (nextProps.bvOpened && !this.props.bvOpened)
        || (this.props.features.length !== nextProps.features.length)
        || (this.props.features.length && nextProps.features.length && nextProps.features[0] && this.props.features[0] &&
        nextProps.features[0].part.getParent().partName !== this.props.features[0].part.getParent().partName)
    ) {
      // this.setState({
      //   showLoader: true
      // }, () => {
      //   this.reorderItems(nextProps);
      // });
      this.reorderItems(nextProps);
    }

    if (!nextProps.isPhoneNumberValidated && this.props.isPhoneNumberValidated) { // if user logged out
      const fabricatorSettings = nextProps.fabricatorData.settings;
      if (fabricatorSettings.leadCapture
        && !(document.kvConfig.isBackend && document.kvConfig.jobId && document.kvConfig.canSaveQuote)) {
        setTimeout(() => {
          this.reorderItems(nextProps);
        },0)
      }
    }

    if (this.needToUpdate && nextProps.features.length !== this.props.features.length) {
      this.reorderItems(nextProps);
      this.needToUpdate = false;
    }

    const childItem = nextProps.childItem && nextProps.childItem.part;
    if (childItem && nextProps.selectedFilters.length) {
      const checkPassed = checkIfNeedToReceiveFeaturesIfFiltersApplied(nextProps.selectedFilters, childItem);
      if (checkPassed) {
        this.getFeaturesFromBackendWithFilters(nextProps.childItem.part, checkPassed.arrayOfNeededFiltersToReceive, 1);
      }
    }

  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  reorderItems = (props) => {
    const selectedFirstItemIndex = this.getActiveItemIndex(props);
    const otherSelectedWallsIndexes = this.getSelectedWallIndexes(props.childItem, props.features, selectedFirstItemIndex); // this part is looking for the same stones that are already selected

    const selectedExist = (selectedFirstItemIndex || selectedFirstItemIndex === 0) && selectedFirstItemIndex > -1;
    const indexesToReplace = selectedExist ? [selectedFirstItemIndex, ...otherSelectedWallsIndexes] : [...otherSelectedWallsIndexes];

    this.childItemText = props.childItem ? props.childItem.text : "";
    this.parentItemText = props.parentItem ? props.parentItem.text : "";
    this.setState({
      reorderedFeatures: this.getReorderedItems(indexesToReplace, props, selectedExist)
    // }, () => {
    //   setTimeout(() => {
    //     if (this._isMounted) {
    //       this.setState({
    //         showLoader: false
    //       })
    //     }
    //   }, 50)
    });
  };

  handleUserLoginClick = (userPopupType = UserPopupTypes.Unlock) => {
    UserLoginButton.handleLoginClick({...this.props, userPopupType});
  };

  renderLoadingList = (activePart) => {
    if (!activePart.counts) {
      return <div className="message-loading-left-panel-spinner message-loading-left-panel-spinner--small"/>
    }
    // console.log('ctivePart.counts', activePart.counts);
    const counts = getActivePartsCounts(activePart, this.props.layoutName);
    // console.log('counts', counts);

    if (!counts) {
      return <div className="message-loading-left-panel-spinner message-loading-left-panel-spinner--small"/>
    }

    const elements = [];
    for (let i = 0; i < counts; i++ ) {
      elements.push(
        <li className="menu-list__item" key={"menu-list__item"+i}>
          <div className="menu-list__item-feature">
            <div className="message-loading-left-panel-spinner message-loading-left-panel-spinner--small"/>
          </div>
        </li>
      );
    }

    return elements
  };

  renderVirtualizedGrid = () => {

    const elements = this.getNavItemsList(true);

    const list = [[]];  // making list for React Virtualized
    let columnIndex = 0;
    elements.forEach((element, index) => {
      if (index % this.props.navigationViewType === 0 && (index !== 0)) {
        list.push([]);
        columnIndex++;
      }
      list[columnIndex].push(React.cloneElement(element))
    });
    // console.log('list', list);

    const menuBody = document.querySelector('.menu-body__content');
    const menuList = document.querySelector('.menu-list');
    return menuList ? (
      <Grid rowCount={list.length}
            columnCount={this.props.navigationViewType}  // 2 or 4
            width={menuList.clientWidth}
            height={menuBody.clientHeight}
            columnWidth={menuList.clientWidth / this.props.navigationViewType}
            onScroll={this.onMobileNavigationScroll}
            rowHeight={this.props.navigationViewType === 4
              ? (window.innerWidth < 720 ? 83 : 103)
              : (window.innerWidth < 720 ? 123 : 143)}
        // cellRenderer={({columnIndex, key, rowIndex, style, isScrolling}) => {
            cellRenderer={({columnIndex, key, rowIndex, style}) => {
              // if (isScrolling) {
              //   return (<div className="button-stacked-container-small" key={uuid.v4()} style={style}>
              //     {this.emptyStone}
              //     {this.emptyStone}
              //   </div>);
              //
              //   // (<div style={style} key={uuid.v4()}>{this.emptyStone}</div>);
              // }
              // console.log('rowIndex:', rowIndex);
              // console.log('columnIndex:', columnIndex);
              // console.log('===================');
              // console.log('element', element);
              return <div key={key} style={style}>
                {list[rowIndex][columnIndex]}
              </div>
            }}>
      </Grid>
    ) : null
  };

  render() {
    const activePart    = this.props.parentItem ? this.props.parentItem.part : null;
    const activeSubPart = this.props.childItem ? this.props.childItem.part : null;
    const activeNavPart = activeSubPart || activePart;

    const fabricatorSettings = this.props.fabricatorData.settings;
    const useWizard = fabricatorSettings &&
      (fabricatorSettings.wizardConsumers || (fabricatorSettings.wizardClients && document.kvConfig.isBackend));

    const showNavigationFilters = useWizard && this.props.activeNavigationFilter && activeNavPart
      && this.props.activeNavigationFilter !== CABINET_WIZARD_BUTTONS[0].buttonId
      && activeNavPart.canUseNavigationFilter && activeNavPart.canUseNavigationFilter();
    // const showNavigationFiltersSteps = showNavigationFilters && this.props.activeNavigationFilter !== "inlay_type";

    return (
      <ul className={"menu-list menu-list--"+this.props.navigationViewType}>
        {/*{this.state.showLoader ? (*/}
          {/*<div className="message-loading-left-panel-spinner message-loading-left-panel-spinner--small"/>*/}
        {/*) : this.renderItemsList()}*/}
        {this.props.allFeaturesReceived
          ? showNavigationFilters
            ? <NavigationFilters
              activePart={activeSubPart || activePart}
              isMobile={true}
              onItemClick={this.props.onItemClick}
              refreshCB={this.props.refreshCB}
            />
            : (
              <Fragment>
                {this.state.additionalFeaturesLoading || this.props.navigationLoadingActive ? this.getLoadingFeatures() : null}
                {this.renderVirtualizedGrid()}
              </Fragment>
            )
          : this.renderLoadingList(activeNavPart)
        }
      </ul>
    )
  }
}

const mapStateToProps = (store) => ({
  bvOpened: store.bathroomVisualizerState.bvOpened,
  selectedFilters: store.filterState.selectedFilters,
  filterGroups: store.filterState.filterGroups,
  fabricatorData: store.fabricatorState,
  activeNavigationFilter: store.navigationState.activeNavigationFilter,
  navigationViewType: store.navigationState.navigationViewType,
  cartItems: store.cartState.cartItems,
  navigationLoadingActive: store.navigationState.navigationLoadingActive,
  activeQuoteIndex: store.quotesState.activeQuoteIndex,
});
const mapDispatchToProps = {
  changeActivePartRelatedItemIndex,
  toggleSelectionWindow,
  toggleSelectionFeatureInfo,
  setCameFromPage,
  setQtActiveCategory,
  toggleBathroomVisualizerOpen
};

const MobileNavigationBodyNew = connect(mapStateToProps, mapDispatchToProps)(MobileNavigationBodyNewClass);


export default MobileNavigationBodyNew;
